import { action, computed, makeObservable } from 'mobx';
import {DraggableId, DragUpdate, DroppableId} from '../../../../../lib/components/drag-n-drop';
import {logger} from '../../../../../lib/helpers';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {GroupingExerciseModel} from '../models';
import {GroupingExerciseState, GroupState, ItemState, ItemStates} from './models';
import {addItemToGroup, checkAllItems} from './utils';

export class GroupingExerciseStore {
  constructor(readonly id: number,
              readonly model: GroupingExerciseModel,
              readonly stateStore: X9ContentStateStore) {
    makeObservable(this);
  }

  @computed
  get grexState(): GroupingExerciseState | null {
    return this.stateStore.getContentState<GroupingExerciseState>(this.id);
  }

  @computed
  get customGrexState(): GroupingExerciseState {
    const groups = this.customGroupStates;
    const items = this.customItemsStates;
    const itemOrder = this.model.groups.flatMap((value, key) => value.items.map((v, k) => { return `${key}/${k}`}));

    return {
      groups,
      items,
      itemOrder
    }
  }

  @computed
  get customItemsStates(): ItemStates {
    const itemStates: {[index: string]: ItemState} = {} as ItemStates;

    this.model.groups.map((value, key) => 
      value.items.map((v, k) => {
        Object.assign(itemStates, {[`${key}/${k}`]: {checked: false, checkCount: 0}});
      })
    )

    return itemStates;
  }

  @computed
  get customGroupStates(): GroupState[] {
    const item: string[] = [];
    const groupStates: GroupState[] = Array(this.model.groups.length).fill(item);

    return groupStates;
  }

  @computed
  get itemOrder(): readonly string[] {
    const state = this.grexState;
    if (state === null)
      return [];
    return state.itemOrder;
  }

  @computed
  get groupStates(): readonly GroupState[] {
    const state = this.grexState;
    if (state === null)
      return [];
    return state.groups;
  }

  @computed
  get itemStates(): ItemStates {
    const state = this.grexState;
    if (state === null)
      return {};
    return state.items;
  }

  @computed
  get itemPositions(): { readonly [index: string]: number } {
    const result: { [index: string]: number } = {};
    for (let index = 0; index < this.groupStates.length; index++)
      for (let itemId of this.groupStates[index]) result[itemId] = index;

    return result;
  }

  canDropOn = (draggableId: DraggableId, source: DroppableId, destination: DroppableId): boolean => {
    return true;
  };

  onDragUpdate = (update: DragUpdate) => {
    logger.log('DndGapFillingStore.onDragUpdate', update);
  };

  @action
  onDragEnd = (result: DragUpdate): void => {
    logger.log('GrexStore.onDragEnd', result);

    const {draggableId, fromDroppableId, toDroppableId} = result;
    if (fromDroppableId === toDroppableId)
      return;

    let state = this.grexState !== null ? this.grexState : this.customGrexState;
    state = addItemToGroup(state, draggableId, toDroppableId);
    this.updateState(state);
  };

  @action
  check = () => {
    const state = checkAllItems(this.grexState!);
    this.updateState(state);
  };

  @action
  private updateState(state: GroupingExerciseState) {
    this.stateStore.setContentState<GroupingExerciseState>(this.id,
      state);
  }
}
